export default [
    {
      key: 'name',
      label: 'field.requestPurposeName',
      type: 'text',
      operator: '%',
    },
  ];
  